module.exports = __webpack_public_path__ + "img/SWP_Staff_2H_05 (2).e6c60235.png";